export const LANGUAGES = [
  { key: "de", label: "Deutsch" },
  { key: "tr", label: "Türkçe" },
];

const DICT = {
  de: {
    "nav.dashboard": "Übersicht",
    "nav.customers": "Kunden",
    "nav.contracts": "Verträge",
    "nav.documents": "Dokumente",
    "nav.renewals": "Vertragsverlängerungen",
    "nav.tasks": "Aufgaben",
    "nav.communication": "Kundenkommunikation",
    "nav.wawi_overview": "Übersicht",
    "nav.wawi_stock": "Lager",
    "nav.wawi_transfers": "Umlagerungen",
    "nav.wawi_receipt_scan": "Wareneingang (Scan)",
    "nav.wawi_inventory": "Inventur",
    "nav.wawi_categories": "Kategorien",
    "navgrp.crm": "Kundenverwaltung",
    "navgrp.engage": "Kommunikation & Vertrieb",
    "navgrp.wawi": "Warenwirtschaft",
    "navgrp.analyze": "Analyse & KI",
    "navgrp.system": "System",
    "nav.sales": "Vertrieb",
    "nav.wawi": "Warenwirtschaft",
    "nav.wawi_articles": "Artikel",
    "nav.wawi_devices": "Geräte & IMEI",
    "navgrp.mobilfunk": "Mobilfunk & Provisionen",
    "nav.mf_overview": "Übersicht",
    "nav.mf_providers": "Anbieter & Distributoren",
    "nav.mf_tariffs": "Tarife",
    "nav.mf_promotions": "Aktionen & Bundles",
    "nav.mf_rules": "Provisionsmodelle",
    "nav.mf_import": "Import-Center",
    "nav.mf_contracts": "Vertragsabschlüsse",
    "nav.mf_calc": "Provisionsberechnung",
    "nav.mf_settlements": "Abrechnungen",
    "nav.mf_reconcile": "Soll-Ist-Abgleich",
    "nav.mf_claims": "Differenzen & Reklamationen",
    "nav.mf_reports": "Auswertungen",
    "nav.mf_settings": "Einstellungen",
    "nav.reports": "Berichte",
    "nav.ai": "KI-Assistent",
    "nav.integrations": "Integrationen",
    "nav.settings": "Einstellungen",
    "common.search": "Suchen",
    "common.new": "Neu",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.edit": "Bearbeiten",
    "common.delete": "Löschen",
    "common.loading": "Wird geladen…",
    "common.logout": "Abmelden",
    "common.all": "Alle",
    "common.export": "Exportieren",
    "login.title": "Anmelden",
  },
  tr: {
    "nav.dashboard": "Genel Bakış",
    "nav.customers": "Müşteriler",
    "nav.contracts": "Sözleşmeler",
    "nav.documents": "Belgeler",
    "nav.renewals": "Sözleşme Yenilemeleri",
    "nav.tasks": "Görevler",
    "nav.communication": "Müşteri İletişimi",
    "nav.wawi_overview": "Genel Bakış",
    "nav.wawi_stock": "Depo",
    "nav.wawi_transfers": "Transferler",
    "nav.wawi_receipt_scan": "Mal Girişi (Tarama)",
    "nav.wawi_inventory": "Envanter",
    "nav.wawi_categories": "Kategoriler",
    "navgrp.crm": "Müşteri Yönetimi",
    "navgrp.engage": "İletişim & Satış",
    "navgrp.wawi": "Depo Yönetimi",
    "navgrp.mobilfunk": "Mobil & Komisyonlar",
    "nav.mf_overview": "Genel Bakış",
    "nav.mf_providers": "Operatörler & Distribütörler",
    "nav.mf_tariffs": "Tarifeler",
    "nav.mf_promotions": "Kampanyalar & Paketler",
    "nav.mf_rules": "Komisyon Modelleri",
    "nav.mf_import": "İçe Aktarma Merkezi",
    "nav.mf_contracts": "Sözleşmeler",
    "nav.mf_calc": "Komisyon Hesaplama",
    "nav.mf_settlements": "Hesaplamalar",
    "nav.mf_reconcile": "Beklenen-Gerçekleşen",
    "nav.mf_claims": "Farklar & Şikayetler",
    "nav.mf_reports": "Raporlar",
    "nav.mf_settings": "Ayarlar",
    "navgrp.analyze": "Analiz & Yapay Zeka",
    "navgrp.system": "Sistem",
    "nav.sales": "Satış",
    "nav.reports": "Raporlar",
    "nav.ai": "AI Asistanı",
    "nav.integrations": "Entegrasyonlar",
    "nav.settings": "Ayarlar",
    "common.search": "Ara",
    "common.new": "Yeni",
    "common.save": "Kaydet",
    "common.cancel": "İptal",
    "common.edit": "Düzenle",
    "common.delete": "Sil",
    "common.loading": "Yükleniyor…",
    "common.logout": "Çıkış",
    "common.all": "Tümü",
    "common.export": "Dışa aktar",
    "login.title": "Giriş",
  },
};

export function translate(lang, key) {
  return (DICT[lang] && DICT[lang][key]) || (DICT.de[key]) || key;
}
